<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <transition name="view" appear enter-active-class="animated fadeInUp delay">
          <div>
            <full-filter :employees="employees" :projects="projects" :types="types" :dataShown="dataShown" :showAddClock="true"  @update-data="updateData" @get-data="getInformation"></full-filter>
            <progress-bar></progress-bar>
          </div>
        </transition>
      </div>
    </div>
    <div class="row" style="margin-top: -15px;">
      <div class="col-md-12">
        <transition v-if="dataShown" name="view" appear enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown">
          <clocks-table :clocks="employeesClocks" :projects="projects"></clocks-table>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import FullFilter from "../components/Filters/FullFilter";
  import axios from "axios";
  import {setCookie, url} from "../plugins/axios";
  import NotificationTemplate from "./Notifications/NotificationTemplate";
  import ProgressBar from "../components/Progress";
  import ClocksTable from "./EmployeeClocks/ClocksTable";
  export default {
    components: {ClocksTable, ProgressBar, FullFilter},
    name: "EmployeesClocks",
    data(){
      return {
        employees: {},
        projects: {},
        types: {},
        employeesClocks:{},
        employeesClocksOld:{},
        dataShown: false,
      }
    },
    created() {
      this.getEmployees();
      this.getProjects();
      this.getTypes();
    },
    methods:{
      notifyVue(type,message) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: type,
          message:message,
          timeout: 1500
        });
      },
      getEmployees(){
        axios
          .get(url + 'employees-short/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.employees = response.data.result;
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      getProjects(){
        axios
          .get(url + 'projects-short/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.projects = response.data.result
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      getTypes(){
        axios
          .get(url + 'types-short/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.types = response.data.result
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      getInformation(filter){
        this.dataShown = false;
        let data = {};
        if (filter.employee_id > 0){data['employeeId'] = filter.employee_id;}
        if (filter.project_id > 0){data['projectId'] = filter.project_id;}
        if (filter.type_id > 0){data['typeId'] = filter.type_id;}
        if (filter.is_delete  !== 'empty'){data['deleted']  = filter.is_delete}
        if (filter.is_confirm !== 'empty'){data['confirmed'] = filter.is_confirm}
        axios
          .post(url + 'employees-clocks/',
            {data: data},
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.employeesClocksOld = [];
              this.employeesClocks = [];
              this.dataShown = false;
              if (response.data.result !== null){
                let temp = JSON.stringify(response.data.result);
                temp = temp.split('"is_confirm":"0"').join('"is_confirm":false');
                temp = temp.split('"is_confirm":"1"').join('"is_confirm":true');
                temp = temp.split('"is_delete":"0"').join('"is_delete":false');
                temp = temp.split('"is_delete":"1"').join('"is_delete":true');
                temp = temp.split('"is_paid":"0"').join('"is_paid":false');
                temp = temp.split('"is_paid":"1"').join('"is_paid":true');
                this.employeesClocksOld = JSON.parse(temp);
                this.employeesClocks = JSON.parse(temp);
                this.dataShown = true;
              }
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      updateData(){
        if (JSON.stringify(this.employeesClocks) === JSON.stringify(this.employeesClocksOld)){
          this.notifyVue('info','Data was updated');
        }
        else{
          let data = this.difference(this.employeesClocks,this.employeesClocksOld);
          axios
            .put(url + 'update-clocks/',
              {data: data},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.notifyVue('success','Data was updated');
                this.employeesClocksOld = JSON.parse(JSON.stringify(this.employeesClocks));
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
          .catch((error) =>{
            this.notifyVue('danger',error);
          })
        }
      },
      difference(emplSetNew, emplSetOld){
        let result = '[';
        for(let employee in emplSetNew){
          let newObj = emplSetNew[employee];
          let oldObj = emplSetOld[employee];
          for(let index in newObj){
            if (JSON.stringify(newObj[index]) !== JSON.stringify(oldObj[index])){
              let newRec = newObj[index];
              let oldRec = oldObj[index];
              result = result + '{' + '"record_id":' + newRec['record_id'] + ',';
              for(let param in newRec){
                if (JSON.stringify(newRec[param]) !== JSON.stringify(oldRec[param])){
                  result = result + '"' + param + '":"' + newRec[param] + '",';
                }
              }
              result = result.substr(0,result.length-1) + '},';
            }
          }
          result = result.substr(0,result.length-1) + ']';
        }

        return JSON.parse(result);
      },
    },
  }
</script>

<style scoped>

</style>
